import React, { useEffect } from "react";
import { withPrefix } from "gatsby";
import styled from "styled-components";
import Title from "@airasia/phoenix-components/components/Title";
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel";
import FAQ from "@airasia/phoenix-widgets/widgets/FAQ";

import UNIVERSAL_HEADER_DATA from "../../../data/header";
import HERO_BANNER_DATA from "../../../data/id/herobanneridid";
import CATEGORY_DATA from "../../../data/id/categoryidid";
import FAQ_DATA from "../../../data/id/faqidid";
import ProductCarousel_data from "../../../data/id/ProductCarouselidid";
import Article_data from "../../../data/id/articleidid";
import Layout from "../../../components/layout";
import "../../../css/main.css";
import { fireGtmEvent } from "../../../utils/functions";

const ContentWrapper = styled.div`
  max-width: 625px;
  margin-bottom: 24px;

  #title, h2 {
      font-size: 2.5rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 30px;
  }


  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`;

const TitleWrapper = styled.div`
  margin-bottom: 3em;

  #title, h2 {
    font-size: 2.5rem;
    font-weight: 700;
    text-align: center;
  }

  #subtitle {
    font-size: 1.2rem;
    line-height: 2rem;
    text-align: center;
    margin-top: 20px;
    font-weight: 400;
  }

a {
    color: rgb(220, 50, 36);
    text-decoration: none;
  }
  @media only screen and (max-width: 720px){
    width: 90%;
    margin: 2em auto;

    #title {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 10px;
    }

    #subtitle {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
`;

const TextContentWrapper = styled.div`
  width: 90%;
  margin: 0 16px 24px;

   #title, h3 {
        font-size: 2rem;
        font-weight: 700;
        text-align: center;
        margin-bottom: 30px;
    }

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`;

const IndexIDIDPage = () => {
let header = UNIVERSAL_HEADER_DATA;
  header.defaultLocale = [
    {
      data: [
        {
          default: '/id/id/',
          icon: 'LanguageIcon',
          longform: 'Bahasa Indonesia',
          shortform: 'ID'
        }
      ]
    }
  ]
  header.localeList = [
    {
      data: [
        {
          default: '/id/id/',
          longform: 'Bahasa Indonesia',
          shortform: 'ID'
        },
        {
          default: '/',
          longform: 'English (Malaysia)',
          shortform: 'EN'
        },
        {
          default: '/id/',
          longform: 'English (Indonesia)',
          shortform: 'EN'
        },
        {
        default: '/th/',
        icon: 'LanguageIcon',
        longform: 'English (Thailand)',
        shortform: 'EN'
        },
        {
        default: '/th/th/',
        icon: 'LanguageIcon',
        longform: 'ภาษาไทย',
        shortform: 'TH'
        },
      ]
    }
  ]

  const updateLocale = (obj) => {
    window.location.href = withPrefix(obj.detail)
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener("uhfLocaleChange", updateLocale)
    }
  }, [])

  return (
    <Layout
      canonical="https://www.airasia.com/aa/shop/id/id/"
      title="Belanja Online Barang Duty Free Indonesia | airasia Shop Indonesia"
      description="Belanja barang duty free lebih murah dengan airasia Shop. Mulai dari oleh-oleh makanan hingga produk kecantikan, semua ada disini. Belanja sekarang!"
      bannerData={HERO_BANNER_DATA}
      headerData={UNIVERSAL_HEADER_DATA}
    >
    <br />
      <ContentWrapper>
        <TitleWrapper>
          <Title
            accessible
            inverted={false}
            textAlign="left"
            type="h1"
            customProperties={{ id: "title" }}
          >
            airasia shop - Fly High, Great Buys
          </Title>
          <Title
            accessible
            inverted={false}
            textAlign="left"
            theme="AIRASIA_CLASSIC"
            type="h2"
            customProperties={{ id: "subtitle" }}
          >
            Belanja produk duty free di mana saja dengan berbagai opsi pengiriman. <br />Dari Inflight Delivery hingga pengiriman ke rumah, dapatkan berbagai produk duty free menarik dengan harga terbaik!
          </Title>
        </TitleWrapper>
      </ContentWrapper>
      <ContentWrapper>
        <Carousel
          accessible={false}
          allowLocaleFormat={false}
          cardConfig={{
            cardHeaderHeight: "180px",
            customGridTemplate: {
              desktop: "18",
              mobile: "12",
            },
            customImageMinSize: "120px",
            focusEffect: true,
            hoverEffect: true,
            imageHoverAnimation: true,
          }}
          data={CATEGORY_DATA.data}
          templateType="productCategory"
          theme="AIRASIA_CLASSIC"
          widgetName="Carousel"
        />
      </ContentWrapper>
      <br />
      <br />
      <ContentWrapper>
        <Carousel
          accessible
          allowLocaleFormat={false}
          cardConfig={{
            cardHeaderHeight: "300px",
          }}
          data={ProductCarousel_data.data}
          heading={ProductCarousel_data.heading}
          isHideFooter={false}
          isLoading={false}
          showFormattedPrice
          showMoreTextTarget="self"
          templateType="productCard"
          theme="AIRASIA_CLASSIC"
          widgetName="Carousel"
        />
      </ContentWrapper>
      <br /><br /><br />
      <ContentWrapper>
       <Carousel
          accessible
          allowLocaleFormat
          cardConfig={{
            cardBodyMargin: '0',
            cardBodyWidth: '100%',
            cardBorderRadius: '25px',
            cardBoxShadow: '0px 0px 7px rgba(0, 0, 0, 0.1)',
            cardContainerBackgroundColor: 'default',
            cardContainerMargin: '8px',
            cardContainerPadding: '0',
            cardFooterActionIcon: 'ArrowForward',
            cardFooterActionIconBackgroundColor: '#CE1C03',
            cardFooterActionIconBorderRadius: '40px',
            cardFooterActionIconPadding: '2px',
            cardFooterAlignment: 'right',
            columnSpan: '2',
            contentPadding: '13px',
            subtitle: '',
            subtitleFontSize: 'small',
            titleFontColor: 'greyDarker',
            titleFontWeight: 'large'
          }}
          data={Article_data.data}
          heading={Article_data.heading}
          isHideFooter={false}
          isLoading={false}
          localeConfig={{
            date: {
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            },
            time: {
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric'
            }
          }}
          showMoreTextTarget="self"
          templateType="VerticalContentCard"
          theme="AIRASIA_CLASSIC"
          widgetName="Carousel"
      />
      </ContentWrapper>
      <br /><br /><br />
      <TextContentWrapper>
        <FAQ
          titleMarginBottom="normal"
          titleType="h3"
          title="Frequently Asked Questions"
          data={FAQ_DATA}
          openFirstItem
        />
      </TextContentWrapper>
    </Layout>
  );
};
export default IndexIDIDPage;
